import 'css-chunksrc/client/pages/exportsPage/timesheetReport/viewSelect/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_1s6xl_1",
  "input": "_input_1s6xl_7",
  "toggleArrow": "_toggleArrow_1s6xl_23",
  "selectedDataTypes": "_selectedDataTypes_1s6xl_31",
  "placeholder": "_placeholder_1s6xl_40",
  "list": "_list_1s6xl_45",
  "item": "_item_1s6xl_57",
  "typeName": "_typeName_1s6xl_70",
  "opened": "_opened_1s6xl_77"
};